/**
 * Formats ISO date string (YYYY-MM-DD) to display format (DD/MM/YYYY).
 */
export function formatExpiredAt(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
}

/**
 * Maps API vacancy payload to UI shape.
 */
export function mapApiVacancyToUi(apiVacancy) {
  const companyTitle = apiVacancy.company?.title ?? '';
  const label = apiVacancy.hide_brand
    ? apiVacancy.title
    : companyTitle
    ? `${companyTitle} - ${apiVacancy.title}`
    : apiVacancy.title;

  return {
    id: apiVacancy.uid,
    title: apiVacancy.title,
    label,
    outletVillage: apiVacancy.shopping_center?.title ?? '',
    insegna: companyTitle,
    validUntil: formatExpiredAt(apiVacancy.expired_at),
    description: apiVacancy.description ?? '',
    applyEmail: apiVacancy.apply_email ?? '',
    hide_brand: apiVacancy.hide_brand ?? false,
  };
}
